import type * as lazyIndex from './lazyIndex';
import {
    createLazyComponent,
    LazyModule,
    LazyAction,
    registerLazyOrchestrator,
    type LazyComponent,
} from 'owa-bundling';
import initializeNotificationsPaneForAccountAction from 'owa-app-notifications-core/lib/actions/initializeNotificationsPaneForAccountAction';
import type { ImageAndMessageProps } from './components/ImageAndMessage';
import type { ActivityFeedProps } from './components/ActivityFeed';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "ActivityFeedAsync" */ './lazyIndex'),
    { name: 'ActivityFeedAsync' }
);

registerLazyOrchestrator(
    initializeNotificationsPaneForAccountAction,
    lazyModule,
    m => m.initializeNotificationsPaneForAccount
);

export const ActivityFeed: LazyComponent<ActivityFeedProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.ActivityFeed
);
export const lazyInitializeActivityFeed: LazyAction<
    typeof lazyIndex.initializeActivityFeed,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeActivityFeed);
export { ActivityType } from './service/ActivityFeedStorageItem';
export const ActivityFeedTitle: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.ActivityFeedTitle
);
export const lazyLoadActivityFeed: LazyAction<
    typeof lazyIndex.loadActivityFeed,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadActivityFeed);
export const lazyGetUnseenItemsCount: LazyAction<
    typeof lazyIndex.getUnseenItemsCount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getUnseenItemsCount);
export const lazyToggleActivityFeed: LazyAction<
    typeof lazyIndex.toggleActivityFeed,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.toggleActivityFeed);
export { ImageType } from './utils/ImageType';
export const ImageAndMessage: LazyComponent<ImageAndMessageProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.ImageAndMessage);
